import { PageContext } from "@/ui-components/layouts/context";
import { Box, Typography, styled } from "@mui/material";
import { useContext } from "react";

const Title = styled(Typography)({
  color: "var(--soft-black-gray-scale-50)",
  fontFamily: "Nunito Sans",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "28px",
  textTransform: "uppercase",
});

export const TitlesHeader = () => {
  const { title, subtitle } = useContext(PageContext);

  return (
    <>
      <Box
        sx={{
          borderRight: title && subtitle ? "1px solid var(--primary-300);" : "unset",
          pr: "24px",
          mr: "24px",
          flexGrow: title && subtitle ? "0" : "1",
          textAlign: "center",
        }}
      >
        <Title variant="h2">{title}</Title>
      </Box>
      {subtitle && (
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            variant="h3"
            sx={{
              color: "var(--soft-black-gray-scale-50)",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            {subtitle}
          </Typography>
        </Box>
      )}
    </>
  );
};
